import { useState, useEffect } from 'react';
import axios from 'axios';
import { Receipt, Mail } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { PaymentsTable, money } from './PaymentsTable';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AccountStatementCard() {
    const [data, setData] = useState(null);
    const [error, setError] = useState(false);
    useEffect(() => {
        axios.get(`${API}/billing/my-statement`).then(r => setData(r.data)).catch(() => setError(true));
    }, []);
    if (error) return null;
    return (
        <Card className="card-aviation" data-testid="account-statement-card">
            <CardHeader className="pb-3">
                <CardTitle className="text-base font-['Barlow_Condensed'] uppercase tracking-wide flex items-center gap-2">
                    <Receipt className="w-4 h-4 text-primary" /> Estado de cuenta
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
                {!data ? <p className="text-sm text-muted-foreground">Cargando…</p> : (
                    <>
                        <div className="flex items-start gap-2 rounded-md border border-sky-500/30 bg-sky-500/5 p-3 text-sm" data-testid="billing-message">
                            <Mail className="w-4 h-4 text-sky-400 mt-0.5 flex-shrink-0" /><span>{data.billing_message}</span>
                        </div>
                        {data.pending_total > 0 && (
                            <p className="text-sm" data-testid="statement-pending-total">Saldo pendiente: <strong className="font-mono">{money(data.pending_total)}</strong></p>
                        )}
                        <PaymentsTable payments={data.payments} testid="statement-table" />
                    </>
                )}
            </CardContent>
        </Card>
    );
}
